<template>
  <section class="content mt-5">
    <mdb-container>
      <mdb-row>
        <mdb-col col="12" md="8" offset-md="2">
          <h3 class="h3-responsive text-muted font-weight-bold mb-4">個人設定</h3>
          <mdb-card>
            <mdb-card-body class="mx-4">
              <validation-observer v-slot="{ handleSubmit }">
                <form novalidate @submit.prevent="() => { validated = true; handleSubmit(onSubmit) }" class="secondary-form">
                  <validation-provider name="メールアドレス" rules="required|email" v-slot="{ errors }">
                    <custom-mdb-input
                      class="mt-5 mb-0"
                      label="メールアドレス"
                      name="email"
                      type="email"
                      v-model="innerUser.email"
                      :customValidation="validated && errors.length != 0"
                      :isValid="errors.length == 0"
                      :invalidFeedback="errors[0]"
                    />
                  </validation-provider>
                  <small v-if="user.unconfirmedEmail" class="text-muted">メールアドレス変更確認メールを送信済み({{ user.unconfirmedEmail }})</small>
                  <validation-provider name="氏名" rules="required" v-slot="{ errors }">
                    <custom-mdb-input
                      class="my-5"
                      label="氏名"
                      name="name"
                      type="text"
                      v-model="innerUser.name"
                      :customValidation="validated && errors.length != 0"
                      :isValid="errors.length == 0"
                      :invalidFeedback="errors[0]"
                    />
                  </validation-provider>
                  <div class="text-center mt-3 mb-4">
                    <mdb-btn rounded color="primary" type="submit" :class="{ 'disabled': httpRequesting }">
                      <span v-if="httpRequesting" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      更新する
                    </mdb-btn>
                  </div>
                  <div class="modal-footer font-small pt-3">
                    <router-link :to="{ name: 'account' }" class="font-weight-bold">
                      <mdb-icon icon="id-card" class="mr-2"/>契約情報
                    </router-link>
                  </div>
                </form>
              </validation-observer>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>
      </mdb-row>
    </mdb-container>
  </section>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'User',
  data() {
    return {
      innerUser: null,
      validated: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      httpRequesting: 'httpRequesting'
    })
  },
  methods: {
    async onSubmit() {
      await this.updateUser(this.innerUser)
      this.innerUser = Object.assign({}, this.user)
    },
    ...mapActions({
      updateUser: 'auth/update'
    })
  },
  created() {
    this.innerUser = Object.assign({}, this.user)
  }
}
</script>
